import React from "react";
import { Link } from "react-router-dom";
import "./home-card.css";

const HomeCard = React.memo(({ path, title }) => {
  return (
    <Link to={path} className="home-card d-block text-center p-4 rounded-4" aria-label={`Go to interview: ${title}`}>
      {title}
    </Link>
  );
});

export default HomeCard;
